import { ThemeColors } from '../../../'

export interface DropdownColors {
  Background: {
    Default: ThemeColors
    Hover: ThemeColors
    Active: ThemeColors
    Disabled: ThemeColors
  }
  Border: {
    Default: ThemeColors
    Hover: ThemeColors
    Active: ThemeColors
  }
  BoxShadow: ThemeColors
  FontColor: ThemeColors
  Window: {
    Background: ThemeColors
    Border: ThemeColors
    BoxShadow: ThemeColors
  }
  Items: {
    FontColor: ThemeColors
    Background: {
      Default: ThemeColors
      Hover: ThemeColors
      Selected: ThemeColors
      Active: ThemeColors
    }
  }
  Icon: ThemeColors
}

export const dropdownColors: DropdownColors = {
  Background: {
    Default: {
      default: 'bg.panel',
    },
    Hover: {
      default: 'bg.default',
    },
    Active: {
      default: 'bg.default',
    },
    Disabled: {
      default: 'bg.panel',
    },
  },
  Border: {
    Default: {
      default: 'border.default',
    },
    Hover: {
      default: 'border.default',
    },
    Active: {
      default: 'border.default',
    },
  },
  BoxShadow: {
    default: 'shadows.default',
  },
  FontColor: {
    default: 'fg.default',
  },
  Window: {
    Background: {
      default: 'bg.panel',
    },
    Border: {
      default: 'border.default',
    },
    BoxShadow: {
      default: 'overlay.dark',
    },
  },
  Items: {
    FontColor: {
      default: 'fg.default',
    },
    Background: {
      Default: {
        default: 'bg.panel',
      },
      Hover: {
        default: 'bg.muted',
      },
      Selected: {
        default: 'brand.subtle',
      },
      Active: {
        default: 'bg.emphasized',
      },
    },
  },
  Icon: {
    default: 'fg.default',
  },
}
